/**
* Copyright (c) 2019 Vendor Badge, LLC All Rights Reserved.
* Created Date: Monday, 8th April 2019
* 
*  Functional Component for Password
*/
import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

// Material UI
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import InputAdornment from '@material-ui/core/InputAdornment';
import FormControl from '@material-ui/core/FormControl';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import FormHelperText from '@material-ui/core/FormHelperText';

const PasswordInput = (props) => {
  const { classes, id, disabled, onChange, showPasswordText, showPasswordToggle, hasIcon, InputProps, InputLabelProps, labelText, helperText, pattern, ...rest } = props;

  return (
    <FormControl>
      <InputLabel htmlFor={id} {...InputLabelProps}>{labelText}</InputLabel>
      <Input
        id={id}
        name='Password'
        type={showPasswordText ? 'text' : 'password'}
        pattern={pattern}
        fullWidth
        onChange={onChange}
        endAdornment={
          <InputAdornment position='end'>
            {disabled
              ? <Tooltip title={showPasswordText ? 'Hide Password Text' : 'Show Password Text'} placement='left-start'>
                  <IconButton aria-label='Show Password Text' onClick={showPasswordToggle} className={classes.iconButton} >
                    {showPasswordText ? <Visibility /> : <VisibilityOff />}
                  </IconButton>
                </Tooltip>
              : <IconButton aria-label='Show Password Text' onClick={showPasswordToggle} className={classes.iconButton} disabled={props.disabled}>
                  {showPasswordText ? <Visibility /> : <VisibilityOff />}
                </IconButton>
            }
            
          </InputAdornment>
        }
        {...InputProps}
        {...rest}
      />
      {helperText ? <FormHelperText className={classes.helperText}>{helperText}</FormHelperText> : null}
    </FormControl>
  )
}

PasswordInput.propTypes = {
  classes: PropTypes.object.isRequired,
  id: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  showPasswordText: PropTypes.bool,
  showPasswordToggle: PropTypes.func,
  hasIcon: PropTypes.bool,
  labelText: PropTypes.string,
  InputProps: PropTypes.object,
  InputLabelProps: PropTypes.object,
  helperText: PropTypes.array,
  pattern: PropTypes.string
}

PasswordInput.defaultProps = {
  InputProps: {
    margin: 'dense',
  },
  hasIcon: true,
  labelText: 'Password*',
}

const styles = theme => ({
  iconButton: {
    color: theme.palette.type === 'light' ? 'rgb(128, 128, 128)' : theme.palette.common.white,
    padding: '0',
  },
  helperText: {
    width: 275,
  }
});

export default withStyles(styles, { withTheme: true })(PasswordInput);